const countdownBars = document.querySelectorAll(".countdown");

countdownBars.forEach(countdown => {
const dateEl = countdown.querySelector(".countdown-date");
const timerEl = countdown.querySelector(".banner-timer");

if (!dateEl || !timerEl) return;

const endDateString = dateEl.getAttribute("data-countdown");
const endTime = new Date(endDateString).getTime();

function updateTimer() {
    const now = Date.now();
    const distance = endTime - now;

    if (distance <= 0) {
    timerEl.innerHTML = "Expired";
    clearInterval(interval);
    return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((distance / (1000 * 60)) % 60);
    const seconds = Math.floor((distance / 1000) % 60);

    timerEl.querySelector(".days").textContent = days;
    timerEl.querySelector(".hours").textContent = hours;
    timerEl.querySelector(".minutes").textContent = minutes;
    timerEl.querySelector(".seconds").textContent = seconds;
}

updateTimer();  // first run
const interval = setInterval(updateTimer, 1000);

});
